import { IContent } from '../../../services/content/models';
import { getIncludedResource } from '../util';

export const fromJsonApi = (data, included = []): IContent[] => {
  return data.map((item) => {
    const content = {
      id: item.id,
      name: item.attributes.name,
      slug: item.attributes.slug,
      duration: item.attributes.duration,
      event: item.attributes.event,
      contentType: item.attributes.content_type,
      sections: item.attributes.sections,
      priority: item.attributes.priority,
      fromDate: item.attributes.from_date,
      toDate: item.attributes.to_date,
      created_at: item.attributes.created_at,
      updated_at: item.attributes.updated_at,
      metadata: item.attributes.metadata,
      templateKey: '',
    };

    const template = getIncludedResource(item, included, 'template', false);

    if (template) {
      content.templateKey = template.attributes.key;
    }

    if (included) {
      included.forEach((include) => {
        if (include.type === 'files' && content.sections && include.id === content.sections.top_image) {
          content.sections.top_image = include.attributes.url;
        }
      });
    }

    return content;
  });
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/data/api/transformers/content.tsx